import {Enumify} from "./Enumify";
import {formatTransactionReferralToForm} from "../helpers/businessHelper";

export default class TransactionReferralEnum extends Enumify<string> {
    static readonly subscription = new TransactionReferralEnum('SUBSCRIPTION');
    static readonly transfer = new TransactionReferralEnum('TRANSFER');
    static readonly event = new TransactionReferralEnum('EVENT');
    static readonly credit = new TransactionReferralEnum('CREDIT');
    static readonly event_penality = new TransactionReferralEnum('EVENT_PENALITY');
    static readonly event_penality_late = new TransactionReferralEnum('EVENT_LATE_PENALITY');
    static readonly event_penality_absence = new TransactionReferralEnum('EVENT_ABSENCE_PENALITY');
    static readonly _ = this.closeEnum();

    constructor(value: string) {
        super();
        this.value = value;
    }

    get translated() {
        return formatTransactionReferralToForm(this)
    }
}
